var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24px","height":"24px","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("send")]),_c('path',{attrs:{"d":"M3.25,19.5,20.75,12,3.25,4.5v5.83L15.75,12,3.25,13.67Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }